module.exports = __webpack_public_path__ + "media/images/global/icons/groom-e5029e7726fd8ed4ef39fb7bb42f6b89.svg";